export const FETCH_ASSETS_INIT = 'FETCH_ASSETS_INIT';
export const FETCH_ASSETS_DONE = 'FETCH_ASSETS_DONE';
export const FETCH_ASSETS_FAIL = 'FETCH_ASSETS_FAIL';
export const FETCH_ASSETS_DEFERRED = 'FETCH_ASSETS_DEFERRED';
